import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { FloatButton } from 'antd';
import { ArrowUpOutlined } from '@ant-design/icons';

export const ScrollTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Automatically scroll page to top when route changed (some long pages updating partially and not scrolling automatically)
    window.scrollTo(0, 0);
  }, [pathname]);

  return <FloatButton.BackTop shape="square" icon={<ArrowUpOutlined />} description="Top" />;
};
